import * as React from "react";
const SvgWifiOff20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m19.707 1.707-2.266 2.266A15.03 15.03 0 0 1 20.198 6H20l-1.287 1.352a13.03 13.03 0 0 0-2.746-1.905l-1.498 1.499A11.01 11.01 0 0 1 17.333 8.8l-1.38 1.449a8.993 8.993 0 0 0-3.025-1.763l-1.633 1.633a6.975 6.975 0 0 1 3.277 1.58l-1.381 1.45a4.98 4.98 0 0 0-3.815-1.111l-6.669 6.668-1.414-1.414 17-17 1.414 1.414Zm-6.233.697A15.041 15.041 0 0 0 10 2 14.947 14.947 0 0 0-.188 5.99L0 6l1.288 1.352A12.952 12.952 0 0 1 10 4c.597 0 1.185.04 1.76.118l1.714-1.714ZM9.878 6.001a10.958 10.958 0 0 0-7.21 2.8l1.38 1.449a8.983 8.983 0 0 1 3.49-1.909l2.34-2.34ZM10 17.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgWifiOff20Px;
